module.exports = __webpack_public_path__ + "08b65597fbf6e0c8fe41320a5d988764.svg";